// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9a51b808","239":"5d8af26f","455":"e4a82929","488":"5b5c24ec"}[chunkId] + ".chunk.js";
};